import { WysiwygField } from '../../../libs/gs-component-form';
import { Content } from '../../../libs/gs-component-right-rail';
import { Field as FormikField } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { Maybe, ParagraphItemsFragment } from '../../../generated/graphql';
import { SharedFormProps } from '../../../helpers/useManageItem';
import { Footer } from '../../FormComponents';
import { DeleteOrDiscard } from '../DeleteOrDiscard';
import styles from './styles.scss';
import { useAiTextExperimentContext } from '../../../context/AiTextExperimentContext';

export const validationSchema = Yup.object().shape({
  content: Yup.string().required('Text Block cannot be blank'),
});

export interface Attributes {
  pageId: number;
  content: string;
}

export interface InitialValues {
  content: string;
}

const EDITOR_MODULES = [['bold', 'italic'], ['link'], [{ align: [] }]];
const EDITOR_FORMATS: string[] = ['bold', 'italic', 'link', 'align'];

export const initialValues = (item?: Maybe<ParagraphItemsFragment>): InitialValues => ({
  content: item?.content || '',
});

const Form: React.FC<SharedFormProps> = ({ submitForm, loading, updating, isNew, discardOrDelete, close }) => {
  const { showAiButton } = useAiTextExperimentContext();
  return (
    <>
      <Content className={`${styles.content} paragraph-item`} loading={loading}>
        <FormikField
          name="content"
          placeholder="Tell your story here..."
          modules={EDITOR_MODULES}
          formats={EDITOR_FORMATS}
          component={WysiwygField}
          bounds=".paragraph-item"
          showAiButton={showAiButton}
        />
        <div className={styles.removeContainer}>
          <DeleteOrDiscard isNew={isNew} onClick={discardOrDelete}>
            Delete text block
          </DeleteOrDiscard>
        </div>
      </Content>
      <Footer
        primaryOnClick={submitForm}
        secondaryOnClick={close}
        showSpinner={loading || updating}
        useSaveAndPreview={true}
      />
    </>
  );
};

export default Form;
